import React from 'react';
import PropTypes from 'prop-types';
import Numberbox from '../number-box';
import FormField from './form-field';
import FormContext from '../../contexts/form-context';

const NumberField = React.forwardRef(function NumberFieldImpl(props, ref) {
  const {name, values, touched, errors, setFieldValue, handleBlur, ...rest} = props;
  const {} = React.useContext(FormContext);
  const inputRef = React.useRef();

  delete rest.handleChange;

  React.useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    },
  }));

  const handleChange = value => {
    setFieldValue(name, value);
  };

  return (
    <Numberbox
      name={name}
      value={values[name]}
      onChange={handleChange}
      onBlur={handleBlur}
      isInvalid={touched[name] && !!errors[name]}
      ref={inputRef}
      {...rest}
    />
  );
});

NumberField.propTypes = {
  controlProps: PropTypes.object,
  name: PropTypes.string,
  values: PropTypes.object,
  touched: PropTypes.object,
  changed: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
};

export default function FormNumberbox(props) {
  const {controlProps, ...rest} = props;

  return (
    <FormField {...rest}>
      <NumberField {...controlProps} />
    </FormField>
  );
}

FormNumberbox.propTypes = {
  /** Additional props to pass to the FormControl. */
  controlProps: PropTypes.object,
};
